<template>
  <section class="toggle">
    <div class="toggle__head">

      <div v-for="(lang, i) in languages" :key="i"   
            class="toggle__btn" 
              :class="{ 'toggle__btn_active': activeStep === i }" 
              @click="activeStep = i">
              {{ lang.short_name }} 
              {{ $route.name !== 'AmwayUA' ? '- версия' : '' }}
      </div>

    </div>

    <div class="toggle__content">
      <div class="form_east-side">


        <section v-show="activeStep === 0">
          <div>
            <p class="modal__label">Заголовок</p>
            <el-form-item
              prop="inputTitleFirst"
              :rules="[ { required: true, message: 'Title is required'} ]" 
            >
              <el-input type="textarea" 
                        maxlength="100"
                        show-word-limit
                        class="form_textarea_east-side" 
                        v-model="parentData.inputTitleFirst">
              </el-input>
            </el-form-item>
          </div>

          <div class="_mt-15">
            <p class="modal__label">Дополнительный текст</p>
            <el-form-item
              prop="inputTextFirst"
            >
              <el-input type="textarea" 
                        maxlength="150"
                        show-word-limit
                        class="form_textarea_east-side" 
                        v-model="parentData.inputTextFirst">
              </el-input>
            </el-form-item>
          </div>

          <div class="_mt-15">
            <p class="modal__label">Текст кнопки</p>
            <el-form-item
              prop="inputTxtBtnFirst"
            >
              <el-input type="textarea" 
                        maxlength="20"
                        show-word-limit
                        class="form_textarea_east-side_sm" 
                        v-model="parentData.inputTxtBtnFirst">
              </el-input>
            </el-form-item>
          </div>
        </section>

        <section v-show="activeStep === 1">
          <div>
            <p class="modal__label">Заголовок</p>
            <el-form-item
              prop="inputTitleSecond"
            >
              <el-input type="textarea" 
                        maxlength="100"
                        show-word-limit
                        class="form_textarea_east-side" 
                        v-model="parentData.inputTitleSecond">
              </el-input>
            </el-form-item>
          </div>

          <div class="_mt-15">
            <p class="modal__label">Дополнительный текст</p>
            <el-form-item
              prop="inputTextSecond"
            >
              <el-input type="textarea" 
                        maxlength="150"
                        show-word-limit
                        class="form_textarea_east-side" 
                        v-model="parentData.inputTextSecond">
              </el-input>
            </el-form-item>
          </div>

          <div class="_mt-15">
            <p class="modal__label">Текст кнопки</p>
            <el-form-item
              prop="inputTxtBtnSecond"
            >
              <el-input type="textarea" 
                        maxlength="20"
                        show-word-limit
                        class="form_textarea_east-side_sm" 
                        v-model="parentData.inputTxtBtnSecond">
              </el-input>
            </el-form-item>
          </div>
        </section>

        <section v-show="activeStep === 2">
          <div>
            <p class="modal__label">Заголовок</p>
            <el-form-item
              prop="inputTitleThird"
            >
              <el-input type="textarea" 
                        maxlength="100"
                        show-word-limit
                        class="form_textarea_east-side" 
                        v-model="parentData.inputTitleThird">
              </el-input>
            </el-form-item>
          </div>

          <div class="_mt-15">
            <p class="modal__label">Дополнительный текст</p>
            <el-form-item
              prop="inputTextThird"
            >
              <el-input type="textarea" 
                        maxlength="150"
                        show-word-limit
                        class="form_textarea_east-side" 
                        v-model="parentData.inputTextThird">
              </el-input>
            </el-form-item>
          </div>

          <div class="_mt-15">
            <p class="modal__label">Текст кнопки</p>
            <el-form-item
              prop="inputTxtBtnThird"
            >
              <el-input type="textarea" 
                        maxlength="20"
                        show-word-limit
                        class="form_textarea_east-side_sm" 
                        v-model="parentData.inputTxtBtnThird">
              </el-input>
            </el-form-item>
          </div>
        </section>


      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'EastSideForm',
  props: ['parentData', 'languages'],
  data() {
    return {
      isFirstStep: true,
      activeStep: 0,
    }
  }
}
</script>

<style lang="scss" scoped>
.modal__label {
  font-weight: 400;
  font-size: 15.5px;
  line-height: 20px;
  letter-spacing: -.5px;
  margin-bottom: 10px;
  color: #56565A;
}

.form_east-side {
  box-sizing: border-box;
  border-radius: 2px;
  padding: 22px 0;
}

.toggle {
  width: 100%;
  padding-top: 35px;
  &__head { 
    display: flex;
    box-sizing: border-box;
    width: 100%;
  }

  &__btn {
    display: flex;
    justify-content: center;
    height: 50px;
    background: #FFFFFF;
    font-size: 16px;
    line-height: 22px;
    border: 0;
    box-sizing: border-box;
    padding: 13px 0;
    width: 100%;
    color: #56565A;
    border-bottom: 2px solid transparent;

    cursor: pointer;
    transition: all .3s ease;

    &:focus { outline: none; }
    &_active {
      background: #F2F9FC;
      padding: 13px 0 12px;
      border-width: 0 0 2px 0;
      border-color: #034580;
      border-style: solid;
      font-weight: 700;
      color: #034580;
    }
  }
}

.form_textarea_east-side { height: 108px; }
.form_textarea_east-side_sm { height: 83px; }
</style>